import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { branch } from 'baobab-react/higher-order';

import styles from './index.module.scss';

const Comment = ({ onChange, comment }) => {
  const [state, setState] = useState('');
  const [initialStateFilled, setInitialStateFilled] = useState(false);
  const onStateChange = useCallback(
    e => {
      setState(e.target.value);
    },
    [setState],
  );

  useEffect(() => {
    onChange(state);
  }, [state, onChange]);

  useEffect(() => {
    if (!initialStateFilled && comment.length > 0) {
      setState(comment);
      setInitialStateFilled(true);
    }
  }, [comment, initialStateFilled]);

  return (
    <fieldset className={styles.fieldset}>
      <legend>Комментарий</legend>
      <textarea value={state} onChange={onStateChange} />
    </fieldset>
  );
};

Comment.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default branch({}, Comment);
